export function paramSelector<T>(_state: unknown, param: T) {
  return param;
}

export const stringSelector = (_state: unknown, str: string) => str;
